import { DefaultError, useMutation } from "@tanstack/react-query";
import updateAdmin, { UpdateAdminParams } from "../api/updateAdmin";
import { invalidateAdminListQuery } from "../queries/useAdminListQuery";

const useUpdateAdminMutation = (onSuccess: () => void) => {
  return useMutation<unknown, DefaultError, UpdateAdminParams>({
    mutationFn: async (params) => {
      await updateAdmin(params);
    },
    onSuccess: async () => {
      onSuccess();
      await invalidateAdminListQuery();
    },
    onError: (e) => {
      alert(e.message);
    },
  });
};

export default useUpdateAdminMutation;
